import './registerServiceWorker'
switch (process.env.VUE_APP_KEY) {
  case 'app':
  default:
    require('@/main.app');
    break;
}
